import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { InstallationArea, Installation } from '../../interfaces/installation';
import { firestore } from 'firebase/app';

import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class InstallationsAreasService {
  private installationsAreasCollection: AngularFirestoreCollection<InstallationArea>;
  private installationsAreas: Observable<InstallationArea[]>;
  public installationsAreasData: InstallationArea[];
  public installationIDAreasData: InstallationArea[];

  constructor(private afs: AngularFirestore, private autServ: AuthService) {
    this.installationsAreasCollection = this.afs.collection<InstallationArea>('areas');
    this.installationsAreas = this.installationsAreasCollection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as InstallationArea;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  getInstallationsAreas(): Observable<InstallationArea[]> {
    //  // console.log(this.installationsAreasCollection);
    //  // console.log(this.installationsAreas);
    return this.installationsAreas;
  }

  getInstallationArea(id: string): Observable<InstallationArea> {
    console.log(id);
    return this.installationsAreasCollection
      .doc<InstallationArea>(id)
      .valueChanges()
      .pipe(
        take(1),
        map(installationArea => {
          installationArea.id = id;
          return installationArea;
        })
      );
  }

  addInstallationArea(area: InstallationArea, installationDocId: string, data: any): Promise<void> {
    return new Promise((resolve, reject) => {
      area.name = area.name.toLowerCase();
      area.installationRef = this.afs.firestore.collection('installations').doc(installationDocId);
      area.created = {
        userRef: this.autServ.userRef,
        ts: firestore.Timestamp.fromDate(new Date()),
      };
      if (data.accessAreasRef && data.accessAreasRef.length > 0) {
        const accessAreasRef = [];
        data.accessAreasRef.forEach(element => {
          accessAreasRef.push(this.afs.firestore.collection('areas').doc(element));
        });
        area.accessAreasRef = accessAreasRef;
      }
      this.installationsAreasCollection
        .add(area)
        .then((obj: any) => {
          //  // console.log(obj);
          const a = this.afs.firestore.collection('areas').doc(obj.id);
          a.update({
            id: obj.id,
            accessAreasRef: firestore.FieldValue.arrayUnion(a),
          });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  updateInstallationArea(area: InstallationArea, data: any): Promise<void> {
    data.name = data.name.toLowerCase();
    if (data.accessAreasRef.length > 0) {
      const accessAreasRef = [];
      data.accessAreasRef.forEach(element => {
        accessAreasRef.push(this.afs.firestore.collection('areas').doc(element));
      });
      data.accessAreasRef = accessAreasRef;
    }
    return this.installationsAreasCollection.doc(area.id).update(data);
  }

  getInstallationIDAreas(installationDocId: string): Observable<InstallationArea[]> {
    const installationDocRef = this.afs.firestore.collection('installations').doc(installationDocId);
    this.installationsAreasCollection = this.afs.collection<InstallationArea>('areas', ref => {
      return ref.where('installationRef', '==', installationDocRef);
    });
    return this.installationsAreasCollection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as InstallationArea;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  filterInstallationsAreas(filter: string): Observable<InstallationArea[]> {
    filter = filter.toLowerCase();
    if (filter.length === 0) {
      return this.installationsAreasCollection
        .valueChanges()
        .pipe(map(items => items.filter(item => item.name !== '')));
    }
    const strFrontCode = filter.slice(0, filter.length - 1);
    const strEndCode = filter.slice(filter.length - 1, filter.length);

    const startCode = filter;
    const endCode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);

    return this.installationsAreasCollection
      .valueChanges()
      .pipe(map(items => items.filter(item => item.name >= startCode && item.name <= endCode)));
  }
}
